export default __webpack_public_path__ + "static/media/undraw_add_to_cart.468a12fe.svg";